// extracted by mini-css-extract-plugin
export var dropdown = "_sj-0";
export var imageWrapper = "_sj-3";
export var itemNameContainer = "_sj-1";
export var productImage = "_sj-2";
export var spinnerWrapper = "_sj-4";